import {ErrorHandler, ModuleWithProviders, NgModule} from "@angular/core";
import {DefaultErrorHandler} from "./DefaultErrorHandler";
import {ExceptionLogger} from "./ExceptionLogger";

@NgModule({
  providers: []
})
export class NErrorLoggingModule {
  static forRoot(): ModuleWithProviders<NErrorLoggingModule> {
    return {
      ngModule: NErrorLoggingModule,
      providers: [
        {provide: ErrorHandler, useClass: DefaultErrorHandler},
        ExceptionLogger
      ]
    };
  }
}
